<template>
  <BaseDrawer
    v-if="product"
    :is-open="isOpen"
    :shrink="true"
    @close="handleCloseDialog"
  >
    <template #title>
      {{ product.name }}
    </template>
    <div class="flex flex-col justify-center space-y-2 p-4">
      <!-- product info -->
      <div>
        <div class="flex items-center justify-between">
          <div class="text-xs text-background-fg/70">
            Price
          </div>
          <div class="text-sm font-semibold">{{
            formatToMerchantCurrencyString(product.price)
          }}</div>
        </div>
        <div class="flex items-center justify-between">
          <div class="text-xs text-background-fg/70">
            VAT
          </div>
          <div
            v-if="product.vatRate"
            class="text-sm font-semibold"
          >
            {{ product.vatRate }}%
          </div>
          <div v-else class="text-sm text-background-fg/40">
            None
          </div>
        </div>
      </div>

      <!-- Product Tag Chips -->
      <div
        v-if="tags.length > 0"
        class="flex w-full justify-center space-x-1"
      >
        <div
          class="flex-1 self-center text-xs text-background-fg/70"
        >
          TAGS
        </div>
        <div
          v-for="tag in tags"
          :key="tag.id"
          class="relative inline-flex items-center justify-between rounded-full bg-background-fg/30 px-2.5 py-1 text-xs font-medium text-background"
          :style="{
            backgroundColor:
              PRODUCT_TAG_COLOR_MAP[tag.color].color,
          }"
        >
          {{ tag.label }}
        </div>
      </div>
    </div>
  </BaseDrawer>
</template>

<script setup lang="ts">
import {
  type ProductTag,
  useProductTags,
} from "@/services/product-tags/listProductTags"
import { PRODUCT_TAG_COLOR_MAP } from "@/services/product-tags/productTagColors"
import type { Product } from "@/services/sharedTypes/products"

const { formatToMerchantCurrencyString } = useCurrency()

const props = defineProps<{
  product: Product | null
  isOpen: boolean
}>()

const emit = defineEmits<{
  (eventName: "update:isOpen", value: boolean): void
}>()

const handleCloseDialog = () => {
  emit("update:isOpen", false)
}

const { data: productTags } = useProductTags()
const tags = computed(() =>
  productTags.value && props.product
    ? props.product.tagIds.reduce((agg, v) => {
        const tag = productTags.value.find(
          (_tag) => _tag.id === v && !_tag.isHidden
        )

        return tag ? [...agg, tag] : agg
      }, [] as ProductTag[])
    : []
)
</script>
